import React, { Component } from 'react';
import Header from '../header/header';

class About extends Component {

  render() {
    return (
      <div>
        <div className="about-section">
          <Header />
        </div>
      </div>
    );
  }

}

export default About;



// WEBPACK FOOTER //
// ./src/components/about/about.js